/* On-brand Kaching slide cart: teksten in de jij-vorm + USP's en betaaliconen onder de afrekenknop. */
(function () {
  var TEXT = {
    'Uw winkelwagen': 'Je winkelmand',
    'Onze andere bestsellers': 'Maak je routine compleet',
    'Doorgaan naar afrekenen': 'Veilig afrekenen'
  };
  var queued = false;

  function swapBadges(root) {
    root.querySelectorAll('.kaching-cart__badge, .kaching-cart-item__price-info *').forEach(function (el) {
      if (el.children.length === 0 && /^U bespaart/.test(el.textContent.trim())) el.textContent = el.textContent.replace('U bespaart', 'Je bespaart');
    });
    root.querySelectorAll('.kaching-cart__badge').forEach(function (el) {
      el.childNodes.forEach(function (n) { if (n.nodeType === 3 && /U bespaart/.test(n.textContent)) n.textContent = n.textContent.replace('U bespaart', 'Je bespaart'); });
    });
  }

  function swapText(root) {
    root.querySelectorAll('.kaching-cart__heading, .kaching-cart-product-upsell-carousel__title, .kaching-cart__checkout-button-label').forEach(function (el) {
      var t = el.textContent.trim();
      if (TEXT[t] && el.textContent !== TEXT[t]) el.textContent = TEXT[t];
    });
  }

  function addExtras(root) {
    var footer = root.querySelector('.kaching-cart__footer');
    var tpl = document.getElementById('lx-cart-extras');
    if (!footer || !tpl || footer.querySelector('.lx-cx')) return;
    var node = tpl.content.firstElementChild.cloneNode(true);
    var btn = footer.querySelector('.kaching-cart__checkout-button');
    if (btn) btn.after(node); else footer.appendChild(node);
  }

  function run() {
    queued = false;
    document.querySelectorAll('.kaching-cart').forEach(function (root) { swapText(root); swapBadges(root); addExtras(root); });
  }
  function schedule() { if (!queued) { queued = true; requestAnimationFrame(run); } }

  function start() {
    run();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* Prijsvergelijking bij het totaal: oude prijs doorgestreept + "Je bespaart" (bundelkorting, cadeaus en codes).
   Leest /cart.js, dus de bedragen zijn exact wat Shopify rekent. */
(function () {
  var FREE_SHIP = 6500, last = '', busy = false, data = null;
  function eur(c) { return '€' + (c / 100).toFixed(2).replace('.', ','); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); }

  function rows(c) {
    var out = [], gifts = {}, disc = {}, save = 0;
    c.items.forEach(function (i) {
      var off = i.original_line_price - i.final_line_price;
      if (off <= 0) return;
      if (i.final_line_price === 0) {
        var n = i.product_title;
        gifts[n] = (gifts[n] || 0) + off;
      } else {
        var t = (i.discounts && i.discounts[0] && i.discounts[0].title) || 'Korting';
        disc[t] = (disc[t] || 0) + off;
      }
    });
    Object.keys(disc).forEach(function (t) { out.push({ l: t, v: disc[t] }); save += disc[t]; });
    Object.keys(gifts).forEach(function (n) { out.push({ l: 'Gratis ' + n.toLowerCase(), v: gifts[n], gift: true }); save += gifts[n]; });
    (c.cart_level_discount_applications || []).forEach(function (d) {
      out.push({ l: 'Code ' + d.title, v: d.total_allocated_amount }); save += d.total_allocated_amount;
    });
    return { rows: out, save: save, orig: c.total_price + save };
  }

  function render(foot) {
    var sub = foot.querySelector('.kaching-cart__subtotal');
    if (!sub || !data) return;
    var r = rows(data);
    var was = sub.querySelector('.lx-cs-was'), line = foot.querySelector('.lx-cs-line');
    if (!r.save) { if (was) was.remove(); if (line) line.remove(); return; }
    var amt = sub.querySelector(':scope > span');
    if (amt && !was) { was = document.createElement('s'); was.className = 'lx-cs-was'; amt.before(was); }
    if (was && was.textContent !== eur(r.orig)) was.textContent = eur(r.orig);
    if (!line) { line = document.createElement('p'); line.className = 'lx-cs-line'; sub.after(line); }
    var t = 'Je bespaart ' + eur(r.save);
    if (line.textContent !== t) line.textContent = t;
  }

  function refresh() {
    var foot = document.querySelector('.kaching-cart .kaching-cart__footer');
    if (!foot) return;
    var sub = foot.querySelector('.kaching-cart__subtotal');
    var key = (sub ? sub.textContent : '') + '|' + document.querySelectorAll('.kaching-cart-item').length;
    if (key === last && data) { render(foot); return; }
    if (busy) return;
    busy = true; last = key;
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
      .then(function (c) { data = c; render(foot); })
      .catch(function () {}).then(function () { busy = false; });
  }
  var q = false;
  new MutationObserver(function () { if (!q) { q = true; setTimeout(function () { q = false; refresh(); }, 150); } })
    .observe(document.body, { childList: true, subtree: true, characterData: true });
  refresh();
})();
